var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6123 4.00177L14.1846 5.38869C15.1388 6.40553 15.7084 7.6092 15.7084 8.99972C15.7084 10.3902 15.1351 11.6837 14.1846 12.6107L15.616 14.0013C17.0474 12.7042 17.7131 10.8537 17.8093 8.99972C17.8056 7.14929 17.1398 5.29887 15.6123 4.00177Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 8.99969H19.9029C19.9029 6.68576 18.9486 4.55507 17.3286 2.88789L18.76 1.49738C20.8572 3.44481 22.0001 6.13242 22.0001 8.99969Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7598 16.5022L17.3284 15.1117C19.0446 13.4445 19.9027 11.3138 19.9027 8.99988H21.9998C21.9998 11.8707 20.8569 14.5583 18.7598 16.5022Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.963 18C10.6782 18 10.4895 17.9066 10.3009 17.7233L4.72695 13.135H1.03934C0.473435 13.135 0 12.6751 0 12.1253V5.8806C0 5.33086 0.473435 4.87095 1.03934 4.87095H4.72695L10.3009 0.279019C10.5857 0.00235352 11.0555 -0.0874727 11.3403 0.0957734C11.7175 0.27902 11.9062 0.645512 11.9062 1.0156V16.9903C11.9062 17.3568 11.7175 17.7233 11.3403 17.9102C11.2478 18 11.0591 18 10.963 18ZM2.07868 11.1157H5.10422C5.38902 11.1157 5.57766 11.2091 5.76629 11.3924L9.92364 14.7878V3.21814L5.76629 6.61718C5.57766 6.80043 5.38902 6.89385 5.10422 6.89385H2.07868V11.1157Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/VolumeIcon.d53b41230f7a7bb09cc2e5f5d7bf6ec7.svg";
export { ForwardRef as ReactComponent };